module.exports = __webpack_public_path__ + "static/img/empty-avatar.e4c06a10.svg";